<template>
  <div style="width: 100%">
    <v-row align="center" style="max-height: 56px">
      <v-col cols="auto">
        <div class="title text--secondary text-uppercase">
          {{ $t("management.modes.title") }}
        </div>
      </v-col>
      <v-col class="text-right">
        <v-btn
          color="primary"
          class="white--text"
          :loading="loading || this.$apollo.loading"
          @click="openNewModeDialog([], null)"
          v-if="role('admin', 'safetyRepresentative')"
        >
          {{ $t("management.modes.addNew") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      :items="modes"
      :headers="headers"
      class="safety-elevation-3 table-striped"
      :loading="loading || $apollo.loading"
      :footer-props="{
        'items-per-page-text': `${$t('employees.footer.itemsPerPage')}`,
        'items-per-page-all-text': `${$t('employees.footer.all')}`,
      }"
    >
      <template v-slot:[`item.name`]="{ item }">
        <a
          v-if="role('admin', 'safetyRepresentative')"
          href="#"
          @click="changeModeTranslation(item.locales, item.id)"
        >
          {{ item.name }}
        </a>
        <span v-else>{{ item.name }}</span>
      </template>
    </v-data-table>
    <upsert-translation
      v-if="translationDialog"
      :dialogTitle="translationDialog.dialogTitle"
      :id="translationDialog.id"
      :translation="translationDialog.translation"
      :show="translationDialog.show"
      :loading="loading || this.$apollo.loading"
      @hide="translationDialog = null"
      @add="saveMode(translationDialog.id, $event)"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import UpsertTranslation from "@/components/management/component/UpsertTranslation.vue";

import ModesWithLocalesQuery from "@/graphql/queries/mode/ModesWithLocales.gql";
import CreateModeMutation from "@/graphql/mutation/mode/CreateMode.gql";
import UpdateModeMutation from "@/graphql/mutation/mode/UpdateMode.gql";

export default {
  components: {
    UpsertTranslation,
  },
  data() {
    return {
      translationDialog: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["role"]),
    headers() {
      return [
        {
          text: "ID",
          value: "id",
          class: "text-uppercase subheading text-truncate",
        },
        {
          text: this.$i18n.t("management.modes.name"),
          value: "name",
          class: "text-uppercase subheading text-truncate",
        },
      ];
    },
  },
  methods: {
    changeModeTranslation(translation, id) {
      this.translationDialog = {
        show: true,
        translation,
        id,
        allTranslations: [],
        dialogTitle: this.$i18n.t("management.modes.change"),
      };
    },
    openNewModeDialog(translation, id) {
      this.translationDialog = {
        show: true,
        translation,
        id,
        allTranslations: [],
        dialogTitle: this.$i18n.t("management.modes.addNew"),
      };
    },
    saveMode(id, translations) {
      const locales = translations.map(({ language, text }) => ({
        language,
        text,
      }));

      const mutation = id ? UpdateModeMutation : CreateModeMutation;

      this.$apollo
        .mutate({
          mutation: mutation,
          variables: id ? { id, locales } : { locales },
        })
        .then((res) => {
          if (id) {
            let updatedMode = this.modes.find((m) => m.id == id);
            if (updatedMode) {
              Object.assign(updatedMode, res.data.mode);
            }
          } else {
            this.modes.push(res.data.mode);
          }
        })
        .catch((err) => {
          this.$store.commit("push_global_message", {
            text: err,
            color: "error",
          });
        });
    },
  },
  apollo: {
    modes: {
      query: ModesWithLocalesQuery,
    },
  },
};
</script>
